module.exports = __webpack_public_path__ + "static/img/g-health.8880661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/g-health.png
// module id = tycR
// module chunks = 1